import React from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';

const correctTopSpacer = () => {
  const viewportHeight = document.body.clientHeight;
  const contentHeight = document.getElementById('react-root').offsetHeight;
  const topSpacerHeight = viewportHeight * 0.15;

  if (topSpacerHeight * 2 > (viewportHeight - contentHeight)) {
    document.getElementById('top-spacer').classList.add('fixed');
  } else {
    document.getElementById('top-spacer').classList.remove('fixed');
  }
};

export default (WrappedComponent) => {
  class CorrectTopSpacer extends React.Component {
    componentDidMount() {
      correctTopSpacer();
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return setDisplayName(wrapDisplayName(WrappedComponent, 'CorrectTopSpacer'))(CorrectTopSpacer);
};
